export default __webpack_public_path__ + "0d751f4bd5d875d67adbf455b3a8e1ae.svg";